// Shared rather than page-local: utils/certificationAccess reads the certification tab to build the
// pending-certification allow-list, and a src/utils module reaching into app/pages is the same
// inward layering that left catchAsyncActionError undefined at import time (see constants/authPaths).
export const COMPANY_MANAGER_TABS = {
  CERTIFICATION: 'certification',
  TASKS: 'tasks',
  TEAM: 'team',
  SECURITY_GROUPS: 'security-groups',
  LOAN_ROLES: 'loan-roles',
  PIPELINE_ACCESS: 'pipeline-access',
  COMPENSATION: 'compensation',
  CREDIT_PROVIDERS: 'credit-providers',
  APPROVALS: 'approvals',
  COMPANY_PROFILE: 'company-profile',
  BRANDING: 'branding',
  CUSTOM_DOMAINS: 'custom-domains',
};

export const COMPANY_MANAGER_DEFAULT_TAB = COMPANY_MANAGER_TABS.CERTIFICATION;

// Tabs reachable while the sub-company's certification is still pending. Tasks stays reachable
// because a submitted certification can still be waiting on the broker: the deferred authorized
// signer completes Attestation / Compensation Plans and signs the disclosures from their tasks.
export const CERTIFICATION_PENDING_ALLOWED_TABS = [
  COMPANY_MANAGER_TABS.CERTIFICATION,
  COMPANY_MANAGER_TABS.TASKS,
];
